import logo from '../kaf-logo-white-yellow.png';

export default function Footer() {
    return (
        <div className="footer-outer">
            <div className="footer">
                <div className="footer-inner">
                    <div className="footer-first-row">
                        <a href="#">Terug naar website</a>
                        <a href="#">Algemene voorwaarden</a>
                        <a href="#">Privacy statement</a>
                        <a href="#">Cookieverklaring</a>
                    </div>
                    <div className="footer-logo-row">
                        <img className="px-4 object-contain h-48" alt="logo" src={logo} />
                    </div>
                    <div className="footer-last-row">© 2023 dekafmolen.nl</div>
                </div>
            </div>
        </div>
    )
}